import { z } from 'zod';

export const AttainmentSchema = z.object({
  id: z.string().or(z.number()), 
  name: z
    .string()
    .min(1, 'Название обязательно для заполнения')
    .max(200, 'Название не должно превышать 200 символов'),
  shortName: z
    .string()
    .min(1, 'Короткое название обязательно для заполнения')
    .max(7, 'Короткое название не должно превышать 7 символов'),
  description: z
    .string()
    .max(300, 'Описание не должно превышать 300 символов')
    .optional()
    .or(z.literal('')),
  duration: z.boolean()
});